import { api } from 'api/api';
import { Endpoints } from 'api/constants';
import { IDiscount, IDiscountWithStats } from 'types/income';
import { TableDataResponse } from 'types/general';
import { exportXlsxConfig, getSorting } from 'utils/general';
import { DiscountsFilters, DiscountsWithStatsFilters } from './discounts.types';

const getDiscountsWithStatsFilters = (
  filters: Partial<DiscountsWithStatsFilters>,
) => ({
  page: filters.page,
  pageSize: filters.pageSize,
  ...getSorting(filters.sort),
  search: filters.search || undefined,
  filter: {
    discountPackage: filters.package,
    supplierId: filters.suppliers,
    countries: filters.countries,
    categories: filters.categories,
    validFrom: filters.validAt?.from,
    validTo: filters.validAt?.to,
  },
});

interface GetDiscounts {
  filters: Partial<DiscountsFilters>;
}

interface BulkUpdate {
  enabled?: string[];
  disabled?: string[];
}

interface GetDiscountsWithStats {
  filters: Partial<DiscountsWithStatsFilters>;
}

interface ExportXlsDiscountsWithStats {
  filters: Partial<DiscountsWithStatsFilters>;
}

export const loaders = {
  getDiscounts: ({ filters }: GetDiscounts) => {
    return api<TableDataResponse<IDiscount>>({
      url: Endpoints.clientAdmin.discounts.root,
      params: {
        page: filters.page,
        pageSize: filters.pageSize,
        filter: {
          name: filters.name || undefined,
          status: filters.status,
          discountId: filters.discounts,
          countries: filters.countries,
          cities: filters.cities,
          supplierId: filters.suppliers,
          categories: filters.categories,
          publishDateFrom: filters.publishDate?.from,
          publishDateTo: filters.publishDate?.to,
        },
        sort: filters.sort
          ? `${filters.sort.order === 'desc' ? '-' : ''}${
              filters.sort.columnKey
            }`
          : undefined,
      },
    });
  },
  bulkUpdate: ({ enabled, disabled }: BulkUpdate) => {
    return api({
      url: Endpoints.clientAdmin.discounts.bulkUpdate,
      data: {
        isEnabledIds: enabled ?? [],
        isDisabledIds: disabled ?? [],
      },
      method: 'patch',
    });
  },
  getDiscountsWithStats: ({ filters }: GetDiscountsWithStats) => {
    return api<TableDataResponse<IDiscountWithStats>>({
      url: Endpoints.clientAdmin.discounts.usage.root,
      params: getDiscountsWithStatsFilters(filters),
    });
  },
  exportXlsDiscountsWithStats: ({ filters }: ExportXlsDiscountsWithStats) => {
    const { pageSize, page, ...params } = getDiscountsWithStatsFilters(filters);

    return api({
      url: Endpoints.clientAdmin.discounts.usage.export.xls,
      params,
      ...exportXlsxConfig,
    });
  },
};
